/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AlertCheckIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Alert Check',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.7 27a12.39 12.39 0 0 1 .219-2.278h-1.136a.405.405 0 0 1-.4-.405v-2.433a.406.406 0 0 1 .4-.406h2.237a12.322 12.322 0 0 1 6.909-6.078L15.708 2.482a.811.811 0 0 0-1.416 0L.725 26.76a.811.811 0 0 0 .708 1.207h13.316A12.37 12.37 0 0 1 14.7 27ZM13.378 9.718a.406.406 0 0 1 .4-.406h2.434a.406.406 0 0 1 .405.406v9.733a.405.405 0 0 1-.405.405h-2.429a.405.405 0 0 1-.4-.405Z"
    />
    <path
      d="M27 18.1a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm-2.338 14.312-4.128-4.127a.5.5 0 0 1 0-.707l1.037-1.037a.5.5 0 0 1 .707 0l2.731 2.731 6.106-6.106a.5.5 0 0 1 .707 0l1.043 1.043a.5.5 0 0 1 0 .707l-7.5 7.5a.5.5 0 0 1-.703-.004Z"
    />
  </svg>`;
};
